<template>
    <div>
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
  
            <el-form-item label="日期">
            <el-date-picker
                v-model="search.start_time"
                type="date"
                class="w130"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-date-picker
                v-model="search.end_time"
                type="date"
                class="w130"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
            ></el-date-picker>
            </el-form-item>

            <el-form-item label="市场">
                <el-select v-model="search.market_id" clearable class="w150" placeholder="请选择统归属市场">
                <el-option
                    v-for="item in options.market_id"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                />
                </el-select>
            </el-form-item>

            <el-form-item label="门店/门诊" >
            <el-select
              v-model="search.shop_id"
              clearable
              remote
              filterable
              :remote-method="remoteMethod"
              placeholder="请输入"
              class="w84"
            >
              <el-option
                v-for="item in options.shop_id"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="门店类型">
            <el-select
              v-model="search.shop_type"
              placeholder="请选择门店类型"
              class="w130"
              clearable
            >
              <el-option
                v-for="item in options.shop_type"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            
            </el-select>
          </el-form-item>

  
          </el-form>
        </el-col>
        <el-col :span="2" class="btnBox">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
          <el-button type="primary"  size="mini"  :loading="exportS" @click="exportExcel">导出数据</el-button>
        </el-col>
      </el-row>
  
        <!--列表-->
        <el-row>
          <el-col :span="24">
            <el-table
              :data="list"
              size="small"
              border
              :cell-style="$style.cellStyle"
              :header-cell-style="$style.rowClass"
            >
              <ElTableColumn label="市场名称" prop="market_name" />
              <ElTableColumn label="门店" prop="shop_name" />
              <ElTableColumn label="员工姓名" prop="name" />
              <ElTableColumn label="岗位级别" prop="station_level" />
              <ElTableColumn label="顾客分配人数" prop="customer_num" />
         
              <ElTableColumn label="顾客保有人数" prop="retained_count" />
              <ElTableColumn label="顾客流失人数" prop="lost_count" />
              <ElTableColumn label="业绩金额" prop="perform_amount" />
              <ElTableColumn label="消耗金额" prop="consume_amount" />
              <ElTableColumn label="护理量" prop="num_care" />
              <ElTableColumn label="护理人数" prop="amount_care_num" />
            
            </el-table>
            <pagination
              class="page tc mt10"
              :total="page.total"
              :page.sync="page.page"
              :limit.sync="page.limit"
              @pagination="getList"
            />
          </el-col>
        </el-row>
  
    </div>
  </template>
  
  <script>
  import { getLastDay } from '@/utils';
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { getStaffAnalyse,getShopType } from "@/api/statistics";
  import { getShopList,readAdminMarketList } from "@/api/shop";
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class Search {
    start_time = '';
    end_time   = '';
    market_id  = '';
    shop_id    = '';
    shop_type  = '';
  }
  class Options {
    shop_id = [];
    market_id = [];
    typeOptions = [];
  }
  export default {
    name: "OrderList",
    components: {
      pagination
    },
    data() {
      return {
        search: new Search(), // 检索条件
        options: new Options(),
        page: new Page(), // 分页
        list: [], // 数据展示
        idList: [], // 导出数据
        exportS: false,
      };
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    mounted() {
        this.getOptions();

      let year = new Date().getFullYear()
      let month = new Date().getMonth() + 1
      if(month.toString().length == 1){
        month = '0'+ month
      }
      let day = getLastDay(year,month)
      if(day.toString().length == 1){
        day = '0'+ day
      }
      this.search.start_time = year+'-'+ month + '-01'
      this.search.end_time = year+'-'+ month + '-' + day
      this.getList('search');
    },
    methods: {
        // 获取选项
        getOptions() {
            readAdminMarketList().then(res => {
                this.options.market_id = res.list;
            });
            getShopType().then(res => {
                this.options.shop_type = res.data;
            })
        },
        getList(option) {
            if (option === "search") this.page = new Page();
            getStaffAnalyse({  ...this.search, ...this.page,export:0 }).then(res => {
                this.list = res.data.list;
                // this.list = [];
                // this.page.total = 0;
                this.page.total = res.data.total;
            });
        },

        // 搜索门店
        remoteMethod(e) {
            getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
                this.options.shop_id = res.list;
            });
        },
        exportExcel() {
        this.exportS = true
            getZyCustomer({ ...this.search, ...this.page,export:1}).then(res => {
                window.open(res.data.url);
                this.exportS = false
            });
        },
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .btnBox{
    display: flex;
    justify-content: flex-end;
    width: 60%;
    margin-bottom: 10px;
    .el-button{
      height: 28px;
    }
  }
  .bgW{
    display: flex;
  }
  </style>
  